import React from "react";
import smile from "../media/smile.jpg";
import snow from "../media/snow.jpg";
import styles from "./Lyra.module.css";

const IMAGES: Readonly<string[]> = [smile, snow];

const Lyra: React.FC = () => {
  const [index, setIndex] = React.useState(0);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIndex((index + 1) % IMAGES.length);
  };

  return (
    <div className={styles.lyra}>
      <div className={styles.content}>
        <img
          className={styles.image}
          src={IMAGES[index]}
          onClick={handleClick}
          alt="Lyra the dog"
        />
      </div>
    </div>
  );
};

Lyra.displayName = "Lyra";

export default Lyra;
